import { ConstIsolineSignalLine } from "../core/objects/webgl/signal/const-isoline-signal-line";
import { ConstUniversalSignalBuffer } from "./const-universal-signal-buffer";

export class ConstUniversalSignalLine extends ConstIsolineSignalLine {
  constructor(settings) {
    super(settings);
  }

  createBuffer(settings) {
    this.signalBuffer = new ConstUniversalSignalBuffer(settings);
  }

  loadDataFromSource() {
    this.signalBuffer.loadDataFromSource();

    this.settings.gl.bindBuffer(this.settings.gl.ARRAY_BUFFER, this.glBuffer);
    this.settings.gl.bufferSubData(this.settings.gl.ARRAY_BUFFER, 0, this.signalBuffer.pointBuffer);
  }

  resetSourceBuffer() {
    this.signalBuffer.resetSourceBuffer();
  }
}
